// extracted by mini-css-extract-plugin
module.exports = {"selectList":"LanguagesMenu_selectList__3nOdW","selectItem":"LanguagesMenu_selectItem__3XK-K","active":"LanguagesMenu_active__3hB__"};